(function ($) {
	// add label to quantity input
	$('<label class="quantity-label"><h4>Quantity</h4></label>').insertBefore('.quantity:has(input.qty)');	

	if (typeof itemsInCart != 'undefined') {
		$(".cart-counter").innerHTML = itemsInCart;
	};

	// bug fix: changing qty on small doesn't also change qty on medium up. since update 
	// cart button gets qty values from the last input
	$(document.body).on('change', '.woocommerce-cart-form .woocommerce-cart-form__cart-item.show-for-small-only input.qty.text', function(e) {
		var $target = $(this);
		var inputValue = $target.val();
		$('.woocommerce-cart-form .woocommerce-cart-form__cart-item.show-for-medium input.qty[name="'+$target.attr('name')+'"]').val(inputValue);
	});

	// add span for checkbox at checkout page
	$('#order_free_local_pickup, #order_send_as_gift').after('<span></span>');
	$('label[for=order_send_as_gift]').append('<h4 class="counter-text"><b class="counter-number">200</b> Characters Left </h4>');

	$('#order_send_as_gift').on('click', function(){
		$($('body').find('.counter-text')[0]).toggleClass('active');
	});

	var $giftMsg = $('textarea[name=order_gift_message]');
	var lengthText = 200; 
	
	$giftMsg.attr('maxlength', lengthText);
	$giftMsg.on('change, keydown, keyup', function(e) {
		var tval = $(this).val(),
			tlength = tval.length,
			set = lengthText,
			remain = parseInt(set - tlength);
		var key = event.keyCode || event.charCode;
		var keys = [8, 46, 37, 38, 39, 40];

		$('body').find('.counter-number')[0].innerHTML = remain;
		if (remain <= 0 && (keys.indexOf(key) == -1)) {
			return false;
		}		
	});


	// on resize
	$(window).on('resize', function() {
		var $image = $('.thumbnail-wrapper').find('.attachment-woocommerce_thumbnail');
		var imgWidth = $image.outerWidth();
		var imgHeight = imgWidth * 1.25;
		$image.height(imgHeight); 
	}).trigger('resize');

	$('.carousel').flickity({
		cellSelector: '.carousel-cell',
		cellAlign: 'left', 
		pageDots: true,
		draggable: true,
		prevNextButtons: false,
		contain: true
	});

	var $carousel = $('.carousel-prod-main').flickity({
		prevNextButtons: false,
		draggable: false,
		pageDots: false,
	});
	
	var $carouselNav = $('.carousel-prod-nav');
	var $carouselNavCells = $carouselNav.find('.carousel-cell-medium');
	
	$carouselNav.on( 'click', '.carousel-cell-medium', function( event ) {
		var index = $( event.currentTarget ).index();
		$carousel.flickity( 'select', index );
	});

	var flkty = $carousel.data('flickity');
	//var navTop  = $carouselNav.position().top;
	var navCellHeight = $carouselNavCells.height();
	var navHeight = $carouselNav.height();

	$carousel.on( 'select.flickity', function() {
		// set selected nav cell
		$carouselNav.find('.is-nav-selected').removeClass('is-nav-selected');
		var $selected = $carouselNavCells.eq( flkty.selectedIndex ).addClass('is-nav-selected');
		// scroll nav
		var scrollY = $selected.position().top + $carouselNav.scrollTop() - ( navHeight + navCellHeight ) / 2;

		$carouselNav.animate({
			scrollTop: scrollY
		});
	});

	
	$('.color-variable-wrapper').children().each(function(){
		var $color = this.getAttribute('data-title');
		$(this).append('<span class="color-title"><h4>'+$color+'</h4></span>');
	})

	// select styles
	$('.single-product .summary.entry-summary select, .checkout select, .woocommerce-ordering select').each(function(){
		var $this = $(this), numberOfOptions = $(this).children('option').length;
		var $name = $this.attr('name');

		$this.parent().parent().addClass($name);
		$this.addClass('select-hidden');
		$this.wrap('<div class="select"></div>');
		$this.after('<div class="select-styled"></div>');
		
		var $styledSelect = $this.next('div.select-styled');
		$styledSelect.text($this.children('option').eq(0).text());

		var $list = $('<ul />', {
			'class': 'select-options'
		}).insertAfter($styledSelect);

		for (var i = 0; i < numberOfOptions; i++) {
		if ($this.children('option').eq(i).is(':selected')) {
			$styledSelect.text($this.children('option').eq(i).text());
		}
		}

		$styledSelect.on("click", function(e) {
				e.stopPropagation();
				$('div.select-styled.active').not(this).each(function(){
					$(this).removeClass('active').next('ul.select-options').hide();
				});
				var $selectOptions = $(this).closest('.select').find('.select-options').empty();
				for (var i = 0; i < numberOfOptions; i++) {
					if ( $this.children('option').eq(i).text() !== '') {
						var liProps = {
							text: $this.children('option').eq(i).text(),
							rel: $this.children('option').eq(i).val(),
							class: ($this.children('option').eq(i).attr('disabled') ? 'disabled' : '') + $this.children('option').eq(i).val(),
						};
						$('<li />', liProps).appendTo($selectOptions);
					}
				}			
				$selectOptions.find('li').on("click", function(e) {
					e.stopPropagation();
					if (!$(e.target).is('.disabled')) {
						$styledSelect.removeClass('active');
						$this.val($(this).attr('rel')).trigger("change");
						$selectOptions.hide();		
					}
				});	
		$(this).toggleClass('active').next('ul.select-options').toggle();
		})

			$this.on("change", function() {
			// sync select's value with front label
				var currentValue = $this.val();
				$styledSelect.removeClass('selected');
				for (var i = 0; i < numberOfOptions; i++) {
					if ($this.children('option').eq(i).attr('value') == currentValue) {
						$styledSelect.text($this.children('option').eq(i).text());
						if ($this.children('option').eq(i).val()) {
							$styledSelect.addClass('selected');
						}
					}
				}	
			});

		$(document).on("click", function() {
		$styledSelect.removeClass('active');
		$list.hide();
		})
	});

})(jQuery);

function addQuantityBoxes(a) {
	var b, c = !1;
	a || (a = ".qty"), b = jQuery("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)").find(a), b.length && (jQuery.each(b, function(a, b) {
		"date" === jQuery(b).prop("type") || "hidden" === jQuery(b).prop("type") || jQuery(b).parent().parent().hasClass("tribe-block__tickets__item__quantity__number") || jQuery(b).parent().hasClass("buttons_added") || (jQuery(b).parent().addClass("buttons_added").prepend('<button type="button" class="minus"><span>&ndash;</span></button>'), jQuery(b).addClass("input-text").after('<button type="button" class="plus"><span>+</span></button>'), c = !0)
	}), c && (jQuery("input" + a + ":not(.product-quantity input" + a + ")").each(function() {
		var a = parseFloat(jQuery(this).attr("min"));
		a && 0 < a && parseFloat(jQuery(this).val()) < a && jQuery(this).val(a)
	}), jQuery(".plus, .minus").unbind("click"), jQuery(".plus, .minus").on("click", function() {
		var b = jQuery(this).parent().find(a),
			c = parseFloat(b.val()),
			d = parseFloat(b.attr("max")),
			e = parseFloat(b.attr("min")),
			f = b.attr("step");
		c && "" !== c && "NaN" !== c || (c = 0), "" !== d && "NaN" !== d || (d = ""), "" !== e && "NaN" !== e || (e = 0), "any" !== f && "" !== f && void 0 !== f && "NaN" !== parseFloat(f) || (f = 1), jQuery(this).is(".plus") ? d && (d == c || c > d) ? b.val(d) : b.val(c + parseFloat(f)) : e && (e == c || c < e) ? b.val(e) : 0 < c && b.val(c - parseFloat(f)), b.trigger("change")
	})))
}

function compositeAddQuantityBoxes() {
	addQuantityBoxes()
}
jQuery(window).on("load", function() {
	addQuantityBoxes()
}), jQuery(document).ajaxComplete(function() {
	addQuantityBoxes()
}), jQuery(document).ready(function() {
	jQuery(".yith-wacp-mini-cart-icon").on("click", function() {
		setTimeout(function() {
			addQuantityBoxes()
		}, 100)
	})
}), jQuery(".composite_data").length && jQuery(".composite_data").on("wc-composite-initializing", function(a, b) {
	b.actions.add_action("component_selection_details_animated", compositeAddQuantityBoxes, 10)
});